/*eslint-disable*/
import _ from 'lodash';

export default {
    data() {
        return {
            events: [],
            isLoading: false,
        }
    },
    computed: {
        routineData() {
            let allEvents = [];
            this.events.forEach(event => {
                if (event.day === 7) {
                    event.day = 0;
                }
                let startMoment = this.$moment(event.startDate);
                let endMoment = this.$moment(event.endDate);
                let now = this.$moment();
                while (startMoment.isSameOrBefore(endMoment, 'day')) {
                    if (parseInt(startMoment.format('d')) === event.day && startMoment.isSameOrAfter(now, 'day')) {
                        event.date = startMoment.format('YYYY-MM-DD');
                        allEvents.push(_.cloneDeep(event));
                    }
                    startMoment.add(1, 'day');
                }
            });
            allEvents = _.orderBy(allEvents, 'date');
            return allEvents;
        },
        nearestClasses() {
            return _.take(this.routineData, 5);
        },
    }
}
